import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";

@Injectable()
export class AddFundsToFBOAccountEffects {
	fundRequested = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.fundAccount.fund),
			switchMap((action) =>
				this.adminService.fundAccount(action.consumerContractFundingIncrements).pipe(
					map(() => MpAdminActions.fundAccount.fundSuccess()),
					catchError((error) => of(MpAdminActions.fundAccount.fundFail({ error })))
				)
			)
		)
	);

	constructor(
		private adminService: MpAdminService,
		private actions: Actions
	) {}
}
